import { Card } from './Funnel.styles';

const FunnelCard = () => {
  return (
    <Card>
      <p>Starting Leads</p>
      <p>27</p>
    </Card>
  );
};

export default FunnelCard;
